import LatLng from './LatLng'
import MarkerWithLabel from '@google/markerwithlabel'

interface ThingConfig {
  id: string
  name: string
  isAlias: boolean
  type: string
  subType: string
  contact_on?: boolean
  thing_contact_on?: boolean
  ignition_status?: boolean
  domain?: string
  tags: []
  status: string
  path?: LatLng[]
  lastReport: number
  heading?: string
  position: LatLng
  marker?: MarkerWithLabel
  speed: number
  speedLastModified: number
  signalSensorTimes: object
  servicePlan: object
  services: object
  batteryLevel?: number
  batteryStatus?: boolean
  fuel_cut_off?: boolean
  gpsId: string
  fuel_tank:number
  rpm_engine:number
  telemetry?: object
  created_timestamp: number
  sensors?: object
  ibutton: string
  markerClickListener?: any
  markerMouseoutListener?: any
  markerMouseoverListener?: any
}

interface ThingMap {
  [id: string]: Thing
}

//Se quita la propiedad "readonly" de "class Thing" para poder modificar sus valores dinamicamente mediante WAMP//

class Thing {
  public id: string
  public name: string
  public isAlias: boolean
  public type: string
  public subType: string
  public contact_on?: boolean
  public thing_contact_on?: boolean
  public ignition_status?: boolean
  public domain?: string
  public tags: []
  public status: string
  public path?: LatLng[]
  public lastReport: number
  public heading?: string
  public position?: LatLng
  public marker?: MarkerWithLabel
  public speed: number
  public speedLastModified: number
  public signalSensorTimes: Object
  public servicePlan: object
  public services: object
  public batteryLevel?: number
  public batteryStatus?: boolean
  public fuel_cut_off?: boolean
  public gpsId: string
  public fuel_tank?: number 
  public rpm_engine?: number
  public telemetry?: Object
  public created_timestamp: number
  public sensors?: Object
  public ibutton: string
  public markerClickListener: any
  public markerMouseoutListener: any
  public markerMouseoverListener: any

  constructor(configuration: ThingConfig) {
    this.id = configuration.id
    this.name = configuration.name
    this.isAlias = configuration.isAlias
    this.type = configuration.type
    this.subType = configuration.subType
    this.contact_on = configuration.contact_on
    this.thing_contact_on = configuration.thing_contact_on
    this.ignition_status = configuration.ignition_status
    this.domain = configuration.domain
    this.tags = configuration.tags
    this.status = configuration.status
    this.path = configuration.path
    this.lastReport = configuration.lastReport
    this.heading = configuration.heading
    this.position = configuration.position
    this.marker = configuration.marker
    this.speed = configuration.speed
    this.speedLastModified = configuration.speedLastModified
    this.signalSensorTimes = configuration.signalSensorTimes
    this.servicePlan = configuration.servicePlan
    this.services = configuration.services
    this.fuel_cut_off = configuration.fuel_cut_off
    this.gpsId = configuration.gpsId
    if (this.type == 'flex') this.batteryLevel = configuration.batteryLevel
    if (this.type !== 'flex') this.batteryStatus = configuration.batteryStatus    
    this.fuel_tank = configuration.fuel_tank 
    this.rpm_engine = configuration.rpm_engine
    this.telemetry = configuration.telemetry
    this.created_timestamp = configuration.created_timestamp
    this.sensors = configuration.sensors
    this.ibutton = configuration.ibutton
    this.markerClickListener = configuration.markerClickListener
    this.markerMouseoutListener = configuration.markerMouseoutListener
    this.markerMouseoverListener = configuration.markerMouseoverListener
  }
}

export { Thing, ThingConfig, ThingMap }
